module.exports = __webpack_public_path__ + "img/box.7b0eeb23.png";